import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireScope?: 'api' | 'support';
}

export function ProtectedRoute({
  children,
  requireScope
}: ProtectedRouteProps) {
  const { isAuthenticated, user, initialize } = useAuth();
  const location = useLocation();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    initialize();
    setIsInitialized(true);
  }, []); // Empty deps - only run once on mount

  // Don't redirect until we've checked authentication state
  if (!isInitialized) {
    return null; // or a loading spinner
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireScope && user?.scope !== requireScope) {
    return <Navigate to="/clients" replace />;
  }

  return <>{children}</>;
}